import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginRegister.css';
import { FaLock } from "react-icons/fa";
import { PiBuildingsFill } from "react-icons/pi";
import { BiSolidBuildingHouse } from "react-icons/bi";
import { SiTicktick } from "react-icons/si";

const baseURL = process.env.BASE_URL || '';

const AdminLoginRegister = () => {
  const [action, setAction] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    administration: '',
    administrationName: '',
    password: '',
    confirmPassword: ''
  });

  // Auto redirect if already logged in
  useEffect(() => {
    const adminId = localStorage.getItem('adminId');
    const administration = localStorage.getItem('administration');
    if (adminId && administration) {
      switch (administration.toLowerCase()) {
        case 'hospital':
          navigate('/dashboard/hospital');
          break;
        case 'school':
          navigate('/dashboard/school');
          break;
        case 'shop':
          navigate('/dashboard/shop');
          break;
        default:
          navigate('/dashboard');
      }
    }
  }, [navigate]);

  const registerLink = () => {
    setAction('active');
    setMessage('');
  };

  const loginLink = () => {
    setAction('');
    setMessage('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ADMIN SIGNUP
  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match");
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch(`${baseURL}/api/auth/signup/admin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.msg || 'Signup failed');

      setMessage('Registration successful! Please login.');
      setAction('');
      setFormData({ administration: '', administrationName: '', password: '', confirmPassword: '' });
    } catch (err) {
      setMessage(err.message || 'Signup failed');
    } finally {
      setIsLoading(false);
    }
  };

  // ADMIN SIGNIN
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const res = await fetch(`${baseURL}/api/auth/signin/admin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          administrationName: formData.administrationName.trim(),
          password: formData.password
        })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.msg || 'Login failed');

      localStorage.setItem('adminId', data.adminId);
      localStorage.setItem('administration', data.administration);

      switch (data.administration.toLowerCase()) {
        case 'hospital':
          navigate('/dashboard/hospital');
          break;
        case 'school':
          navigate('/dashboard/school');
          break;
        case 'shop':
          navigate('/dashboard/shop');
          break;
        default:
          navigate('/dashboard');
      }

    } catch (err) {
      setMessage(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='box'>
      <div className={`wrapper ${action}`}>
        {/* SIGN IN FORM */}
        <div className='form-box login'>
          <form onSubmit={handleLogin}>
            <h1>SIGN IN</h1>

            <div className='input-box'>
              <input
                type='text'
                name='administrationName'
                placeholder='Administration Name'
                value={formData.administrationName}
                onChange={handleInputChange}
                required
              />
              <PiBuildingsFill className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='password'
                placeholder='Password'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <FaLock className='icon' />
            </div>

            <div className='remember-forgot'>
              <label><input type='checkbox' /> Remember me</label>
              <a href='#'>Forgot Password?</a>
            </div>

            <button type='submit' disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Sign In'}
            </button>

            {message && (
              <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <div className='register-link'>
              <p>Don't have an account? <a href='#' onClick={registerLink}>Sign Up</a></p>
            </div>
          </form>
        </div>

        {/* SIGN UP FORM */}
        <div className='form-box register'>
          <form onSubmit={handleRegister}>
            <h1>SIGN UP</h1>

            <div className='input-box'>
              <input
                type='text'
                name='administration'
                placeholder='Administration (hospital/school/shop)'
                value={formData.administration}
                onChange={handleInputChange}
                required
              />
              <BiSolidBuildingHouse className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='text'
                name='administrationName'
                placeholder='Administration Name'
                value={formData.administrationName}
                onChange={handleInputChange}
                required
              />
              <PiBuildingsFill className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='password'
                placeholder='Password'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <FaLock className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='confirmPassword'
                placeholder='Confirm Password'
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
              />
              <SiTicktick className='icon' />
            </div>

            <div className='remember-forgot'>
              <label><input type='checkbox' required /> I agree to the terms & conditions</label>
            </div>

            <button type='submit' disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Sign Up'}
            </button>

            {message && (
              <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <div className='register-link'>
              <p>Already have an account? <a href='#' onClick={loginLink}>Sign In</a></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginRegister;
